import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/auth-v4/AuthClientV4.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/auth-v4/AuthFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/auth-v4/AuthModalV4.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/auth-v4/AuthShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/auth-v4/EmailScreen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/auth-v4/InputField.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/auth-v4/MagicLinkBootstrap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/auth-v4/PasswordScreen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/auth-v4/PrimaryButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/auth-v4/ResetPasswordScreen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/auth-v4/SignUpScreen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/auth-v4/VerifyPhoneModalV4.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/auth-v4/VerifyScreen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PopupClientWrapper"] */ "/app/app/components/popup/PopupClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SubscriptionAvailabilityProvider"] */ "/app/app/contexts/SubscriptionAvailabilityContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/LayoutclientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReduxProvider"] */ "/app/app/store/redux.provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/app/store/store.ts");
;
import(/* webpackMode: "eager" */ "/app/app/styles.scss");
;
import(/* webpackMode: "eager", webpackExports: ["FlagProvider"] */ "/app/node_modules/@unleash/nextjs/client.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["ViewTransitions"] */ "/app/node_modules/next-view-transitions/dist/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\",\"latin-ext\",\"cyrillic\",\"cyrillic-ext\",\"greek\",\"greek-ext\",\"vietnamese\"],\"variable\":\"--font-inter\",\"display\":\"swap\",\"preload\":false}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Almarai\",\"arguments\":[{\"subsets\":[\"arabic\",\"latin\"],\"weight\":[\"300\",\"400\",\"700\",\"800\"],\"variable\":\"--font-almarai\",\"display\":\"swap\",\"preload\":false}],\"variableName\":\"almarai\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-intl-tel-input/dist/main.css");
